/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_OverlapsInputs */



/**
* | output |
* | --- |
* | "Fix Overlaps" |
*
* @param {Fix_OverlapsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const fix_overlaps = /** @type {((inputs?: Fix_OverlapsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_OverlapsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Corriger les chevauchements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überlappungen beheben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correggi sovrapposizioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Устранить наложения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Corregir superposiciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("修复重叠")
	if (locale === "ja") return /** @type {LocalizedString} */ ("重複を修正")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओवरलैप को ठीक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Corrigir sobreposições")
	return /** @type {LocalizedString} */ ("Fix Overlaps")
});